module.exports = "<ul class=\"tags\">\n    <li *ngFor=\"let tag of items\">\n        <ng-container *ngIf=\"tag\">\n            <a [vdgmRouterLink]=\"tag.internal_route\"><small class=\"tag\">{{tag.name}}</small></a>\n        </ng-container>\n    </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/tags/tags.template.html
// module id = 767
// module chunks = 2